import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('leadsplus-layout',[_c(VFlex,{attrs:{"xs12":""}},[_c(VContainer,{staticClass:"pa-0",attrs:{"fluid":""}},[_c(VLayout,{attrs:{"row":"","wrap":""}},[_c('iframe',{ref:"iframe",staticClass:"embedded-component-full",attrs:{"src":_vm.embedComponent,"id":"iframe"}})])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }